import { render } from "./SocBlock.vue?vue&type=template&id=4fa1dad8&scoped=true"
import script from "./SocBlock.vue?vue&type=script&lang=js"
export * from "./SocBlock.vue?vue&type=script&lang=js"

import "./SocBlock.vue?vue&type=style&index=0&id=4fa1dad8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4fa1dad8"

export default script